export const filtersToDto = (data) => ({
    search_text: data.searchText || '',
    branches: data.branches || [],
    created_by: data.createdBy || [],
    // advisors: data.advisors || [],
    insurance_carriers: data.insuranceCarriers || [],
    created_at_start: data.createdAtStart,
    created_at_end: data.createdAtEnd,
    updated_at_start: data.updatedAtStart,
    updated_at_end: data.updatedAtEnd,
    vehicle_states: data.vehicleStates || [],
    vehicle_model_start: data.vehicleModelStart,
    vehicle_model_end: data.vehicleModelEnd,
    vehicle_classes: data.vehicleClasses || [],
    vehicle_circulation_cities: data.vehicleCirculationCities || [],
    vehicle_service_types: data.vehicleServiceTypes || [],
    vehicle_is_utilitarian: data.vehicleIsUtilitarian ?? null,
});